// React
import PropTypes from "prop-types";
import { useEffect, useMemo, useState, useContext } from "react";

// @mui material components
import { Card, Fade, Icon, Modal, Tooltip, Menu, MenuItem } from "@mui/material";

import { gql, useLazyQuery, useQuery, useMutation } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import ModalDelete from "components/Modals/Delete";
import CustomPagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import { MessageManager } from "context";
import dataUsuariosVip from "../data/dataUsuariosVip";
import { getUproColor } from "utils/colors";
import ModalAddUsuarioVip from "./ModalAdd";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "70%", xxl: "60%" },
  overflowY: "auto",
};

const GET_USUARIOS_VIP = gql`
  query usuariosVip($page: Int, $order: Order, $filter: JSON) {
    paginationInfo {
      pages
      total
    }
    usuariosVip(pagination: { page: $page, limit: 10 }, order: $order, filter: $filter) {
      id
      nombre
      sistema
    }
  }
`;

const DELETE_USUARIO_VIP = gql`
  mutation deleteUsuarioVip($id: ID!) {
    deleteUsuarioVip(id: $id) {
      id
    }
  }
`;

export default function ModalPedidos({ open, handleClose }) {
  const [usuarioVip, setUsuarioVip] = useState();
  const [rows, setRows] = useState([]);
  const [openMenu, setOpenMenu] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState();
  const { columns, getRows } = dataUsuariosVip;
  const { handleSnackbar } = useContext(MessageManager);
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [page, setPage] = useState(1);
  const [pagesInfo, setPagesInfo] = useState({
    pages: 0,
    total: 0,
  });
  const [orderBy, setOrderBy] = useState({
    campo: "nombre",
    orden: "ASC",
  });
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const handleOrderBy = (campo) => {
    if (orderBy.campo === campo) {
      if (orderBy.orden === "ASC") {
        setOrderBy({
          campo: campo,
          orden: "DESC",
        });
      } else {
        setOrderBy({
          campo: campo,
          orden: "ASC",
        });
      }
    } else {
      setOrderBy({
        campo: campo,
        orden: "ASC",
      });
    }
  };

  const handleSearch = (event) => {
    const newTimeout = setTimeout(() => {
      setPage(1);
      setSearch(event.target.value);
    }, 500);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    setSearchTimeout(newTimeout);
  };

  const [getUsuariosVip, { data: usuariosVip, loading }] = useLazyQuery(GET_USUARIOS_VIP, {
    variables: {
      search: search || null,
      page: page,
      order: { field: orderBy.campo, order: orderBy.orden },
    },
    fetchPolicy: "no-cache",
    cachePolicy: "no-cache",
  });

  const [deleteUsuarioVip] = useMutation(DELETE_USUARIO_VIP);

  const handleDelete = (id) => {
    deleteUsuarioVip({
      variables: {
        id,
      },
    })
      .then(() => {
        getUsuariosVip();
        handleSnackbar("Usuario VIP eliminado correctamente", "success");
      })
      .catch((error) => {
        console.error(error);
        handleSnackbar("Error al eliminar el usuario VIP", "error");
      });
  };

  const handleOpenMenu = (event, item) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    setSelectedItem(item);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const renderMenu = (
    <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(openMenu)} onClose={handleCloseMenu}>
      <MenuItem
        onClick={() => {
          setOpenModalDelete(true);
          handleCloseMenu();
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <SoftBox>
            <SoftTypography variant="p">Eliminar</SoftTypography>
          </SoftBox>
          <SoftBox>
            <Icon
              fontSize="small"
              sx={{
                verticalAlign: "middle",
                color: getUproColor("uproPink"),
              }}
            >
              delete
            </Icon>
          </SoftBox>
        </SoftBox>
      </MenuItem>
    </Menu>
  );
  useEffect(() => {
    setUsuarioVip();
    getUsuariosVip();
    setSearch("");
  }, [open]);

  useEffect(() => {
    if (usuariosVip && usuariosVip.usuariosVip) {
      setRows(getRows(usuariosVip.usuariosVip, handleOpenMenu));
      setPagesInfo(usuariosVip.paginationInfo);
    }
  }, [usuariosVip]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between" p={3}>
              <SoftBox>
                <SoftTypography variant="h6">Configuracion Usuario</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="flex-end">
                <SoftBox mr={2}>
                  <SoftInput
                    placeholder="Escribe aquí..."
                    icon={{ component: "search", direction: "left" }}
                    onChange={handleSearch}
                  />
                </SoftBox>
                <SoftBox mr={2}>
                  <Tooltip title="Agregar nuevo proveedor" placement="top">
                    <SoftButton color="primary" circular onClick={() => setOpenModalEdit(true)}>
                      <Icon>add</Icon>
                      &nbsp;Agregar
                    </SoftButton>
                  </Tooltip>
                </SoftBox>
                <SoftBox display="flex" alignItems="center">
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox
              sx={{
                maxHeight: "50vh",
                overflow: "auto",
              }}
            >
              {loading ? (
                <Loading />
              ) : usuariosVip?.usuariosVip?.length > 0 ? (
                <DataTable columns={columns} rows={rows} order={orderBy} setOrder={handleOrderBy} />
              ) : (
                <SinDatos />
              )}
            </SoftBox>
            <CustomPagination
              loading={loading}
              length={rows?.length}
              total={pagesInfo?.total}
              pages={pagesInfo?.pages}
              page={page}
              setPage={setPage}
              noCard
            />
            {renderMenu}
          </SoftBox>
          <ModalAddUsuarioVip
            open={openModalEdit}
            handleClose={() => {
              setOpenModalEdit(false);
              setUsuarioVip();
            }}
            data={usuarioVip}
            refetch={() => getUsuariosVip()}
          />
          <ModalDelete
            open={openModalDelete}
            handleClose={() => {
              setOpenModalDelete(false);
            }}
            functionDelete={() => {
              handleDelete(selectedItem?.id);
              setSelectedItem();
            }}
            title="Eliminar usuario VIP"
            message="¿Estás seguro que deseas eliminar este usuario VIP?"
          />
        </Card>
      </Fade>
    </Modal>
  );
}

ModalPedidos.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};
